<template>
	<div>
		<template-listagem-vazia
			:textos="textosTemplateListagemVazia"
			:total-itens="totalItens"
			@botao-evento="funcaoAdicionarDocumento"
		>
			<template #acoes>
				<menu-acoes
					v-if="temPermissao && menuAcoesItens"
					class="acessar-ata-itens-btn-mais-acoes"
					:nome-botao="menuAcoesItens.nome"
					:nome="menuAcoesItens.nome"
					cor-icone="--v-error-base"
					icone-primary="add_circle"
					icone-secondary="arrow_drop_down"
					:acoes-menu="menuAcoesItens.itens"
					tamanho-icone-primary="0.9rem"
					tamanho-icone-secondary="0.9rem"
					tamanho-icone-menu="18px"
					@adicionar-documento="funcaoAdicionarDocumento"
					@adicionar-anexo="funcaoAdicionarAnexo"
				>
				</menu-acoes>
			</template>
		</template-listagem-vazia>
	</div>
</template>
<script>
export default {
	name: 'template-listagem-documentos-vazia',
	props: {
		totalItens: {
			type: Number,
			default: 0,
		},
		menuAcoesItens: {
			type: Object,
			default: () => {
				return null
			},
		},
		funcaoAdicionarDocumento: {
			type: Function,
			default: () => {
				console.error('Função de adicionar documento não informada')
			},
		},
		funcaoAdicionarAnexo: {
			type: Function,
			default: () => {
				console.error('Função de adicionar anexo não informada')
			},
		},
		hasAuthority: {
			type: Boolean,
		},
	},
	data() {
		return {
			textosTemplateListagemVazia: {
				titulo: 'Você não possui documento adicionado',
				mensagem: 'Clique no botão para começar',
			},
		}
	},
	computed: {
		temPermissao() {
			return this.hasAuthority
		},
	},
}
</script>
